import React, { useEffect, useState } from "react";
import { Button } from "devextreme-react";
import { useDispatch } from "react-redux";
import { getResourceAPI } from "../../redux/slices/resourceSlice";
import { setUIProperty } from "../../redux/slices/uiSlice";

const ShowVendorsByType = ({ type }) => {
  const dispatch = useDispatch();
  const [clickedPressed, setClickPressed] = useState(false);

  useEffect(() => {
    if (type && clickedPressed) {
      dispatch(
        getResourceAPI({
          path: "vendor",
          query: { enquiry_type: type },
          reduxPath: "vendorsByType",
        })
      );

      dispatch(setUIProperty({ name: "vendorsModalType", value: type }));
    }
  }, [dispatch, type, clickedPressed]);

  return (
    <>
      <Button
        icon="columnchooser"
        type="default"
        disabled={!type}
        style={{ marginRight: "8px" }}
        hint={`Show vendors for type ${type}`}
        onClick={() => {
          setClickPressed(true);
          dispatch(setUIProperty({ name: "showVendorModal", value: true }));
        }}
      />
    </>
  );
};

export default ShowVendorsByType;
